import CaseList from '@nkr/views/opo/case/case-list';

const OpoCases = () => <CaseList />;

export default OpoCases;
